module.exports = __webpack_public_path__ + "static/media/empty.479c2d97.png";